import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { selectAlgoliaImageRootUrl } from '../../store/selectors/settingsSelectors';
import config from '../../config';
import Paragraph from '../Paragraph/Paragraph';
import themeColors from '../../assets/styles/themeColors';

const ProductCardWrap = styled.button`
  cursor: pointer;
  outline: none;
  border: none;
  padding: 9px 12px;
  display: grid;
  grid-template-columns: 67px 1fr;
  grid-gap: 22px;
  text-align: left;
  background-color: ${(props) =>
    props?.isSelected
      ? themeColors.colorBackgroundSecondaryLight
      : themeColors.colorBackgroundPrimary};

  &:hover {
    background-color: ${themeColors.colorBackgroundSecondary};
  }
`;

const ProductImage = styled.img`
  width: 100%;
  object-fit: contain;
`;

const ContentWrap = styled.div`
  display: flex;
  flex-direction: column;
`;

const ProductCard = ({
  product,
  productPrice,
  productName,
  isSelected,
  onClick,
}) => {
  const RootUrl = useSelector(selectAlgoliaImageRootUrl);

  const imgSrc = config.algoliaSearch.imageCode
    .replace('{product_code}', product.ProductCode)
    .replace('{base_url}', RootUrl);

  return (
    <ProductCardWrap onClick={onClick} isSelected={isSelected}>
      {imgSrc && <ProductImage src={imgSrc} alt={productName} />}
      <ContentWrap>
        {productName && <Paragraph fontWeight={600}>{productName}</Paragraph>}
        {productPrice && <Paragraph>{productPrice}</Paragraph>}
      </ContentWrap>
    </ProductCardWrap>
  );
};

ProductCard.propTypes = {
  product: PropTypes.shape({ ProductCode: PropTypes.string }),
  productPrice: PropTypes.string,
  productName: PropTypes.string,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
};

export default ProductCard;
